import authenticatedRequest from '../helpers/authenticatedRequest';
import { API } from '../../common';

export const createExpressAccount = async (shopId, shopData) => {
  try {
    const response = await authenticatedRequest(
      'post',
      `${API.stripe.createExpressAccount}`,
      {
        shopId,
        shopData,
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error creating Express account:', error);
    throw new Error(
      error.response?.data?.error || 'Failed to create Express account'
    );
  }
};

export const checkAccountStatus = async shopId => {
  try {
    const response = await authenticatedRequest(
      'post',
      `${API.stripe.checkAccountStatus}`,
      {
        shopId,
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error checking account status:', error);
    throw new Error(
      error.response?.data?.error || 'Failed to check account status'
    );
  }
};
